import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'customer-g2m-intro',
  templateUrl: './g2m-intro.component.html',
  styleUrls: ['./g2m-intro.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class G2mIntroComponent {
  readonly maxHeight = input<string>(undefined);
}
